var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84615 0C3.23412 0 2.64715 0.243131 2.21437 0.675907C1.78159 1.10868 1.53846 1.69565 1.53846 2.30769V6.15385H0V7.69231H1.53846V15.3846H0V16.9231H1.53846V20.7692C1.53846 21.3813 1.78159 21.9682 2.21437 22.401C2.64715 22.8338 3.23412 23.0769 3.84615 23.0769H17.6923C18.3043 23.0769 18.8913 22.8338 19.3241 22.401C19.7569 21.9682 20 21.3813 20 20.7692V2.30769C20 1.69565 19.7569 1.10868 19.3241 0.675907C18.8913 0.243131 18.3043 0 17.6923 0L3.84615 0ZM7.69231 7.69231C7.69231 6.87626 8.01648 6.09363 8.59352 5.51659C9.17055 4.93956 9.95318 4.61538 10.7692 4.61538C11.5853 4.61538 12.3679 4.93956 12.9449 5.51659C13.522 6.09363 13.8462 6.87626 13.8462 7.69231C13.8462 8.50836 13.522 9.29099 12.9449 9.86802C12.3679 10.4451 11.5853 10.7692 10.7692 10.7692C9.95318 10.7692 9.17055 10.4451 8.59352 9.86802C8.01648 9.29099 7.69231 8.50836 7.69231 7.69231ZM6.15385 16.9231C6.15385 15.699 6.64011 14.5251 7.50566 13.6595C8.37121 12.794 9.54515 12.3077 10.7692 12.3077C11.9933 12.3077 13.1672 12.794 14.0328 13.6595C14.8984 14.5251 15.3846 15.699 15.3846 16.9231V18.4615H6.15385V16.9231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.88b20544774fbeb43b49029aee98efcc.svg";
export { ForwardRef as ReactComponent };